var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"config-option-box"},[_c('section',{staticClass:"header"},[_vm._v("题目设置")]),_c('section',{staticClass:"container"},[_c('field-property',{attrs:{"formData":_vm.formData},on:{"onChangeFormData":_vm.handleFormData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }